import React from 'react';
import { TopToolbar } from 'react-admin';

const sx = {
	justifyContent: 'space-between',
	alignItems: 'center'
};

const CardActions = (props) => (
	<TopToolbar sx={sx} {...props} />
);

export default CardActions;